/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Scan_Added_ToastInputs */

const vi_lot_scan_added_toast = /** @type {(inputs: Lot_Scan_Added_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thêm lô vào phiếu`)
};

/**

* @param {Lot_Scan_Added_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_scan_added_toast = /** @type {((inputs?: Lot_Scan_Added_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Scan_Added_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_scan_added_toast(inputs)
});